import { useState } from "react";
import { Copy, Check } from "lucide-react";

export const CODEPAD_CA = "KoMt1jZzVXwNhBRuB8tkqQcH1rqrz6yvNcctiompump";

/** $CODEPAD contract address with one-tap copy — shown in every header */
export default function HeaderCA({ testid = "header-ca", compact = false, className = "" }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(CODEPAD_CA);
    } catch {
      const t = document.createElement("textarea");
      t.value = CODEPAD_CA;
      document.body.appendChild(t);
      t.select();
      document.execCommand("copy");
      t.remove();
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  };
  const short = `${CODEPAD_CA.slice(0, 4)}…${CODEPAD_CA.slice(-4)}`;
  return (
    <button
      type="button"
      onClick={copy}
      data-testid={testid}
      title={`$CODEPAD CA: ${CODEPAD_CA} — click to copy`}
      aria-label="Copy $CODEPAD contract address"
      className={`group inline-flex items-center gap-2 min-w-0 rounded-lg border border-mint/30 bg-mint-deep/60 hover:border-mint/60 transition-colors font-mono ${
        compact ? "h-9 px-2.5 text-[10px] gap-1.5" : "w-full h-9 px-3 text-[10.5px]"
      } ${className}`}
    >
      {!compact && <span className="text-mint font-bold shrink-0">$CODEPAD</span>}
      <span className={`${compact ? "text-mint font-bold" : "text-fog/70"} shrink-0`}>CA</span>
      <span className="text-snow whitespace-nowrap" data-testid={`${testid}-value`}>{short}</span>
      <span className={`ml-auto shrink-0 ${copied ? "text-mint" : "text-fog group-hover:text-snow"}`}>
        {copied ? <Check size={13} /> : <Copy size={13} />}
      </span>
    </button>
  );
}
